import { FC, memo } from 'react';
import { useCallsScreen } from '../../hooks/screens/useCallsScreen';
import { Calls } from '../../components/Calls/Calls';

export const CallsScreen: FC = memo(() => {
  const props = useCallsScreen();
  return <Calls {...props} />;
});

CallsScreen.displayName = 'CallsScreen';
